import { removeUndefined } from '../../utils/objects.js';
import BaseField from './BaseField.js';
class BooleanField extends BaseField {
    default;
    constructor(data = {}) {
        super({ example: data.example ?? data.default ?? true, ...data });
        this.default = data.default;
        this.proto.type = 'bool';
    }
    toSchema(transport, options) {
        return removeUndefined({
            ...super.toSchema(transport, options),
            type: 'boolean',
            default: this.default,
        });
    }
    fromJSON(input) {
        return input;
    }
}
export default BooleanField;
//# sourceMappingURL=BooleanField.js.map